import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import DashboardLayout from "@/components/DashboardLayout";
import StatusBadge from "@/components/StatusBadge";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function OrdersList() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/orders").then((r) => setItems(r.data.orders || []));
  }, []);

  const filtered = items.filter((o) => !q || (o.order_number || "").includes(q));

  return (
    <DashboardLayout>
      <div className="mb-6">
        <div className="text-xs font-bold tracking-widest text-brand-amber mb-2">الطلبيات</div>
        <h1 className="text-3xl font-bold text-brand-navy">الطلبيات النشطة والمكتملة</h1>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 mb-4 flex items-center gap-3">
        <Search className="w-4 h-4 text-slate-400" />
        <Input placeholder="ابحث برقم الطلبية..." value={q} onChange={(e) => setQ(e.target.value)} className="border-0 focus-visible:ring-0" data-testid="orders-search" />
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid="orders-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs">
              <tr>
                <th className="px-4 py-3 text-start">رقم الطلبية</th>
                <th className="px-4 py-3 text-start">الحالة</th>
                <th className="px-4 py-3 text-start">التقدم</th>
                {user.role !== "workshop_partner" && <th className="px-4 py-3 text-start">المبلغ (ر.س)</th>}
                <th className="px-4 py-3 text-start">تاريخ الإنشاء</th>
                <th className="px-4 py-3 text-start"></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((o) => (
                <tr key={o.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`order-row-${o.order_number}`}>
                  <td className="px-4 py-3 font-semibold text-brand-navy">{o.order_number}</td>
                  <td className="px-4 py-3"><StatusBadge status={o.status} /></td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
                        <div className="h-full bg-brand-amber" style={{ width: `${o.progress_percentage || 0}%` }} />
                      </div>
                      <span className="text-xs text-slate-500">{o.progress_percentage || 0}%</span>
                    </div>
                  </td>
                  {user.role !== "workshop_partner" && <td className="px-4 py-3 font-bold text-brand-navy">{o.total_price?.toLocaleString() || "—"}</td>}
                  <td className="px-4 py-3 text-slate-600">{o.created_at?.slice(0, 10)}</td>
                  <td className="px-4 py-3 text-end"><Link to={`/app/orders/${o.id}`} className="text-brand-amber font-semibold" data-testid={`view-order-${o.order_number}`}>عرض</Link></td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={6} className="px-4 py-12 text-center text-slate-500">لا توجد طلبيات.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
